<template lang='pug'>
  #div-summary
    v-container(fluid, grid-list-xl)
      v-layout(row, wrap)
        v-flex(xs12)
          v-card
            v-card-text.pa-0
              .iframe-container
                h2.text-xs-center.pt-5.grey--text(
                  v-if="!initProcess"
                ) Pressione o botão "Gerar Laudo"
                iframe(
                  frameborder="0"
                  ref="frame"
                  :src="urlReport"
                  @load="load"
                  v-show="loaded")
                .loading
                  v-progress-circular(
                    color="primary"
                    :value="loadProgress"
                    :size="80"
                    v-if="!loaded")
        v-flex(xs12)
          .text-xs-center
            v-btn(@click="dialogPresetPrint = true") alterar parametros
            v-btn(@click="gerarLaudo") gerar laudo
            v-btn(@click="publicar" color="success" v-show="gi.status !== 'PUBLICADO'") publicar
    dialog-preset-print(v-model="dialogPresetPrint" @apply="gerarLaudo")
</template>

<script>
  import { mapState } from 'vuex'
  import dialogPresetPrint from './components/dialogPresetPrint'
  import apiGestation from '../../../api/gestation'
  import api from '@/utils/api'

  const URL_BASE_REPORT = 'https://report-server-dot-ultracarebr.appspot.com/report/'
  export default {
    name: 'uf-summary',

    components: {
      dialogPresetPrint
    },

    computed: {
      ...mapState({
        gi: (state) => state.ultraFetal.gestationInteraction,
        user: (state) => state.user,
        company: (state) => state.ultraFetal.company
      }),
      urlReport () {
        if (!this.initProcess) return ''
        const { iuid } = this.gi
        if (!iuid) return ''
        console.log(iuid)
        return URL_BASE_REPORT + iuid
      }
    },

    watch: {
      'gi.print' (val) {
        // this.gerarLaudo()
      }
    },

    data () {
      return {
        dialogPresetPrint: false,
        loaded: false,
        initProcess: false,
        loadProgress: 0,
        interval: {}
      }
    },

    mounted () {
      this.dialogPresetPrint = true
    },

    methods: {
      startProgress () {
        this.interval = setInterval(() => {
          if (this.loadProgress === 100) {
            clearInterval(this.interval)
          }
          this.loadProgress += 2
        }, 1000)
      },
      load () {
        if (!this.gi.iuid) return
        this.loaded = true
      },
      gerarLaudo () {
        this.loadProgress = 0
        this.loaded = false
        apiGestation.update({
          iuid: this.gi.iuid,
          status: 'ANDAMENTO'
        })
        setTimeout(() => {
          if (this.initProcess) this.$refs.frame.src += ''
          this.initProcess = true
          this.startProgress()
        }, 2000)
      },
      async publicar () {
        try {
          if (!this.gi.forms || !this.gi.forms['gestationalAge.info.accessionNumber']) {
            alert('Não é possível publicar exames sem Código de exame (AN). Favor preencher no formulário "Informações"')
            return
          }
          if (!this.gi.patient || !this.gi.patient.patId) {
            alert('Não é possível publicar exames sem Código (PatId) de paciente. Favor preencher no cadastro do Paciente')
            return
          }

          // Verifica se TOTP está habilitado para a empresa
          if (this.company && this.company.security && this.company.security.totpEnabled) {
            // Solicita código TOTP antes de publicar
            const result = await this.$swal.fire({
              title: 'Verificação de Segurança',
              text: 'Para publicar o laudo, digite o código de autenticação de dois fatores',
              input: 'text',
              inputAttributes: {
                autocapitalize: 'off',
                placeholder: 'Código de 6 dígitos'
              },
              showCancelButton: true,
              confirmButtonText: 'Confirmar',
              cancelButtonText: 'Cancelar',
              showLoaderOnConfirm: true,
              preConfirm: async (code) => {
                try {
                  const response = await api.post('/verifyTOTP', {
                    code,
                    userId: this.user.uid
                  })
                  if (!response.data.valid) {
                    throw new Error('Código inválido')
                  }
                  return true
                } catch (error) {
                  this.$swal.showValidationMessage(error.message)
                }
              },
              allowOutsideClick: () => !this.$swal.isLoading()
            })

            if (!result.value) {
              return
            }
          }

          await apiGestation.update({
            iuid: this.gi.iuid,
            status: 'PUBLICADO'
          })
          this.$router.push('/ultra-fetal/patient/' + this.gi.patient.id)
        } catch (error) {
          console.error('Erro ao publicar laudo:', error)
          this.$swal.fire({
            title: 'Erro',
            text: 'Não foi possível publicar o laudo',
            icon: 'error'
          })
        }
      }
    }
  }
</script>

<style lang='stylus' scoped>
  .iframe-container
    position relative

  .iframe-container, iframe
    width 100%
    height 75vh
    min-height 75vh

  .loading
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
</style>



// WEBPACK FOOTER //
// src/pages/ultra-fetal/summary/index.vue